module.exports = __webpack_public_path__ + "517c5da5bbd5696c87fe526c740a5c4e.svg";